import React from 'react';
import { useSelector, useDispatch } from 'react-redux'

import Time from '../../time/Time'

import {
    modalUpdate,
} from "../../../../../store/actions/settingsActions";

import {
    updateActiveManagementTicketId,
} from "../../../../../store/actions/ticketsActions";

const Ticket = ({ ticket, active }) => {
    const dispatch = useDispatch();
    // Access state slices directly
    const { activeTicketId } = useSelector(state => state.tickets);
    const { authenticatedUser } = useSelector(state => state.auth);
    const { users } = useSelector(state => state.users);
    const { sessions } = useSelector(state => state.sessions);
    const { services, supportDesks } = useSelector(state => state.services);
    const { customers } = useSelector(state => state.customers);

    const handleModalClick = (id = null) => {
        id = id != null ? id : ticket.id
        dispatch(updateActiveManagementTicketId(id))
        dispatch(modalUpdate({ visible: 1, content: "TicketManagement", modalType: 1 }))
    }

    // Early return if required data is missing
    if (!services?.length || !sessions?.length || !users?.length || !supportDesks?.length || !ticket) {
        return null;
    }

    const userListClass = active ? "user-list active" : "user-list";
    
    // Find data objects once to avoid repeated lookups
    const service = services.find(data => data.id === ticket.serviceId);
    const mySession = sessions.find(session => session.userId === authenticatedUser.id);
    const customer = customers.find(customer => customer.mobileNumber === ticket.mobileNumber);
    
    // Agent details (only for active tickets)
    const agent = (ticket.manage && active === 1) ? 
        users.find(agent => agent.id === ticket.manage.userId) : null;
        
    // Convert numeric flags to boolean for clarity
    const isActiveTicket = Number(ticket.status) === 1;
    const isMyActiveTicket = activeTicketId === ticket.id;
    const isMyService = authenticatedUser.services?.includes(ticket.serviceId) || false;
    
    // Handle transferred tickets
    const hasManageInfo = !isActiveTicket && ticket.manage;
    const isTransferred = hasManageInfo && 
        (ticket.manage.supportDeskId != null || ticket.manage.userId != null);
    
    // Check if transferred to my support desk
    const isTransferredToSupportDesk = isTransferred && ticket.manage.supportDeskId != null;
    const isTransferredToMySupportDesk = isTransferredToSupportDesk && 
        mySession && ticket.manage.supportDeskId === mySession.supportDeskId;
        
    // Check if transferred to me as an agent
    const isTransferredToAgent = isTransferred && !isTransferredToSupportDesk;
    const isTransferredToMe = isTransferredToAgent && 
        ticket.manage.userId === authenticatedUser.id;


    // Determine ticket tag color based on status
    let ticketTagColor = {background: 'white'};
    
    if (isMyActiveTicket) {
        ticketTagColor = {background: 'var(--green)', color: '#fff'};
    } else if (!isActiveTicket && !isTransferred && isMyService) {
        ticketTagColor = {background: 'var(--blue)', color: '#fff'};
    } else if (!isActiveTicket && isTransferred && (isTransferredToMySupportDesk || isTransferredToMe)) {
        ticketTagColor = {background: 'var(--red)', color: '#fff'};
    }

    return (
        <div className={userListClass} onClick={() => handleModalClick()} style={{ display: 'flex', flexDirection: 'column', marginBottom: "8px"}}>
            {/* Row 1 - Display in columns */}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', height: 'auto', alignItems: 'center' }}>
                <div className="user-name-and-pic">
                    <div>
                        <div>
                            {ticket.priority ? <span className="status-badge"></span> : null}
                            <span className="user-image-text" style={ticketTagColor}>
                                {`${ticket.ticketLetter}-${ticket.ticketNumber}`}
                            </span> 
                        </div>
                        <p>{service?.name || 'Unknown'}</p>
                    </div>
                </div>
                <div className="user-list-content">
                    <p>
                        {active && agent?.name && agent?.lastname
                            ? `Agent: ${agent.name} ${agent.lastname}`
                            : !ticket.mobileNumber
                                ? "No customer data"
                                : customer?.fullname || "Unavailable"
                        }
                    </p>
                </div>
                <div className="user-list-content ticket-time">
                    <p>
                        <Time created={active ? ticket.sessionStart : ticket.created} />
                    </p>
                </div>
            </div>
            
            {/* Row 2 - Display in columns */}
            {
                ticket.tracking != null 
                ? (
                    <div className="ticketTrackingInfo" style={{ display: 'flex', flexDirection: 'column', width: '100%'}}>
                        {/* Separator */}
                        <div className="ticketTrackingInfoSeparator"></div>
                        <p className="ticketTrackingInfoTitle">Tracking Information</p>
                        {
                            ticket.tracking.packageStatus 
                            ? <p>Package Status:  <strong>{ticket.tracking.packageStatus}</strong></p>
                            : null
                        }
                        <p>Reference Number:  <strong>{ticket.tracking.referenceNumber}</strong></p>
                        <p>Tracking Number: <strong>{ticket.tracking.trackingNumber}</strong></p>
                        <div style={{width:"25px", height:"25px", position:"absolute", right: "10px", bottom: "10px"}}>
                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.0004 4.65762C17.0265 4.64189 17.0482 4.61938 17.0633 4.59232C17.0784 4.56526 17.0863 4.5346 17.0863 4.50339C17.0863 4.47218 17.0784 4.44152 17.0633 4.41446C17.0482 4.3874 17.0265 4.36489 17.0004 4.34916L10.3915 0.387945C9.96861 0.135077 9.4885 0.00190735 8.99972 0.00190735C8.51095 0.00190735 8.03084 0.135077 7.60797 0.387945L1.00033 4.34916C0.9742 4.36489 0.952524 4.3874 0.937459 4.41446C0.922394 4.44152 0.914467 4.47218 0.914467 4.50339C0.914467 4.5346 0.922394 4.56526 0.937459 4.59232C0.952524 4.61938 0.9742 4.64189 1.00033 4.65762L8.9134 9.45982C8.94002 9.476 8.97035 9.48453 9.00124 9.48453C9.03213 9.48453 9.06246 9.476 9.08908 9.45982L17.0004 4.65762ZM0.259558 5.87223C0.233165 5.85651 0.203215 5.84825 0.172738 5.8483C0.142262 5.84836 0.112338 5.85671 0.0859935 5.87252C0.0596491 5.88832 0.0378182 5.91103 0.0227082 5.93833C0.00759819 5.96564 -0.000255089 5.99658 -5.73928e-05 6.02802V13.7902C0.000595845 14.1643 0.09616 14.5316 0.277131 14.8558C0.458102 15.1799 0.718173 15.4495 1.03148 15.6378L8.04802 19.978C8.07432 19.9937 8.10415 20.0019 8.13451 20.0019C8.16488 20.0019 8.19471 19.9937 8.22102 19.978C8.24732 19.9624 8.26918 19.9399 8.28438 19.9127C8.29958 19.8856 8.3076 19.8549 8.30763 19.8235V10.8177C8.3076 10.7864 8.29959 10.7557 8.2844 10.7286C8.26921 10.7014 8.24738 10.6789 8.22109 10.6633L0.259558 5.87223ZM9.69225 10.849V19.8213C9.69228 19.8526 9.7003 19.8834 9.7155 19.9105C9.73071 19.9376 9.75256 19.9602 9.77886 19.9758C9.80517 19.9915 9.835 19.9997 9.86537 19.9997C9.89574 19.9997 9.92557 19.9914 9.95186 19.9758L16.968 15.6356C17.281 15.4475 17.541 15.1783 17.722 14.8546C17.9031 14.5309 17.9989 14.1639 17.9999 13.7902V6.02802C17.9998 5.99673 17.9918 5.96602 17.9765 5.93896C17.9613 5.9119 17.9394 5.88945 17.9131 5.87386C17.8868 5.85826 17.857 5.85006 17.8267 5.85009C17.7964 5.85012 17.7666 5.85837 17.7403 5.87401L9.77879 10.695C9.75257 10.7106 9.73077 10.733 9.71559 10.7601C9.7004 10.7871 9.69236 10.8177 9.69225 10.849Z" />
                            </svg>
                        </div>
                    </div>
                )
                : null
            }
        </div>
    )
}

export default Ticket;
  
  


